export default __webpack_public_path__ + "static/media/logotest.0b2b8d25.png";